"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _axios = _interopRequireDefault(require("axios"));
var _index = require("@/utils/index");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/** packages */
/** utils */
var _default2 = exports.default = {
  props: {
    batchId: {
      type: String,
      default: ''
    },
    isError: {
      type: String,
      default: ''
    },
    // 当前页面用到的 所有下拉options配置
    /**
     * ssbtypeOptions: [] // 店招品牌select
     */
    optConfig: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      loadingComponent: null,
      listLoading: false,
      isLoading: false,
      list: [],
      total: 0,
      currPage: 1,
      limit: 10,
      sourceApi: null
    };
  },
  computed: {
    _batchId: {
      get: function get() {
        return this.batchId;
      },
      set: function set(val) {
        this.$emit('update:batchId', val);
      }
    },
    _isError: {
      get: function get() {
        return this.isError;
      },
      set: function set(val) {
        this.$emit('update:isError', val);
      }
    }
  },
  watch: {
    isLoading: function isLoading(newValue) {
      // pc unlock 锁屏会导致页面晃动
      if (newValue) {
        this.loadingComponent = this.$loading({
          // lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0)'
        });
      } else {
        if (this.loadingComponent) {
          this.loadingComponent.close();
        }
      }
    },
    _batchId: function _batchId(newValue) {
      this.searchData();
    },
    _isError: function _isError(newValue) {
      this.searchData();
    }
  },
  mounted: function mounted() {
    this.fetchData();
  },
  methods: {
    /**
     * 枚举
     */
    /** 格式化 枚举 */
    formatEnum: function formatEnum(key, from) {
      return (0, _index.formatKeyValue)(key, this.optConfig[from]);
    },
    tableIndex: function tableIndex(index) {
      return index + 1;
    },
    fetchData: function fetchData() {
      var _this = this;
      if (this.sourceApi) {
        this.sourceApi.cancel('cancel');
      }
      this.sourceApi = _axios.default.CancelToken.source();
      var param = {
        currPage: this.currPage,
        limit: this.limit,
        smodel: {
          batchId: this._batchId,
          errorFlag: false
        }
      };
      this.listLoading = true;
      this.$api.common.getFttExcelInfo(param, this.sourceApi.token).then(function (res) {
        _this.listLoading = false;
        _this.list = res.data.items;
        _this.total = res.data.totalCount;
      }).catch(function (err) {
        if (_axios.default.isCancel(err)) {
          return false;
        }
        _this.listLoading = false;
      });
    },
    searchData: function searchData() {
      this.currPage = 1;
      this.fetchData();
    }
  }
};